import { useQueryClient } from '@tanstack/react-query';
import produce from 'immer';
import { useAuthStateStore } from '@annunciate/core';
import { TAG_ITEM_CREATE } from '@annunciate/query/dist/queries/tagItem';
import { useMutation } from './base';
const getUUID = useAuthStateStore.getState().getUUID;
export const useTagItemCreateMutation = () => {
    const client = useQueryClient();
    return useMutation(TAG_ITEM_CREATE, {
        onSuccess: (data) => {
            const item = data;
            const uuid = getUUID(true);
            client.invalidateQueries({
                queryKey: ['tag', uuid, { id: item.parentId }],
                exact: true,
            });
            const key = ['tag', uuid];
            client.setQueryData(key, (old) => {
                return produce(old || [], (draft) => {
                    const idx = draft.findIndex((t) => t.id === item.parentId);
                    if (idx > -1) {
                        const tag = draft[idx];
                        const itemIdx = tag.items.findIndex(({ id }) => id === item.id);
                        if (itemIdx <= -1) {
                            tag.items.push(item);
                        }
                    }
                    else {
                        client.invalidateQueries({ queryKey: ['tag', uuid], exact: true });
                        console.log('refetching all `tag` queries');
                    }
                });
            });
        },
    }, (data) => data.item);
};
//# sourceMappingURL=useTagItemCreateMutation.js.map